import { createReducer, on } from '@ngrx/store';
import { IUser } from '../../services/interface/user.interface';
import { loadTokenFromStorage, login, loginFailure, loginSuccess, logout } from './auth.action';
import { AuthState } from './auth.models';

export const initialAuthState: AuthState = {
    user: null,
    token: null,
    loading: false,
    error: null,
};

export const authReducer = createReducer(
    initialAuthState,

    // Login iniciado
    on(login, (state) => ({
        ...state,
        loading: true,
        error: null,
    })),

    // Login com sucesso
    on(loginSuccess, (state, { user, token }) => ({
        ...state,
        user,
        token,
        loading: false,
        error: null,
    })),

    // Login com falha
    on(loginFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error,
    })),

    on(logout, () => initialAuthState),

    on(loadTokenFromStorage, (state, { user, token }) => ({
        ...state,
        user,
        token,
        loading: false,
        error: null,
    })),
);
